import Vue from 'vue';
import App from './App.vue';
import { useRjAuthServer, SimulateInstance } from 'rj-common-framework';
import 'rj-common-framework/lib/style.css';

import router, { menuAuthHandle } from './router';
import store from './store';
import { addClass } from './libs/util';
import { commonServer } from '@/API/home';
import { roleManagementApi } from '@/views/backStageManagement/service';
// import { startApp } from './registeApp';
import API from './API/request/index';

import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';
import '../theme/index.css';
import '@/assets/iconfont/iconfont.css';
import '@/assets/iconfont_o/iconfont.css';
import VueLazyLoad from 'vue-lazyload';

// vxe-table渲染器
import './common/vxeTableConfigure';
// 原型方法扩展
import './utils/prototypeExtension';
import seatImage from '@/assets/images/seatImage.png';
import Router from 'vue-router';

import VueAwesomeSwiper from 'vue-awesome-swiper';
import 'swiper/swiper-bundle.css';

// 国际化
import i18n from '@/lang/index';

import 'xe-utils';
import VXETable from 'vxe-table';
import 'vxe-table/lib/style.css';

VXETable.setup({
  // 对组件内置的提示语进行国际化翻译
  i18n: (key, args) => {
    try {
      if (typeof key !== 'string') return key;
      // 如果翻译不存在则直接返回原始 key，避免 vue-i18n 的警告
      return i18n.te(key) ? i18n.t(key, args) : key;
    } catch (e) {
      return key;
    }
  },
  // 可选，i18n自定义部分，对参数中的列头、校验提示..等进行自动翻译
  translate (key, args) {
    try {
      if (typeof key !== 'string') return key;
      return i18n.te(key) ? i18n.t(key, args) : key;
    } catch (e) {
      return key;
    }
  }
});
Vue.use(VXETable);

Vue.use(VueAwesomeSwiper);
// Vue.prototype.$swiper = new VueAwesomeSwiper()
Vue.use(ElementUI);
Vue.use(VueLazyLoad, {
  error: seatImage,
  loading: seatImage
});

const originalPush = Router.prototype.push;
Router.prototype.push = function push (location) {
  return originalPush.call(this, location)
    // eslint-disable-next-line handle-callback-err
    .catch((reason) => {
    });
};

Vue.config.productionTip = false;
 let reurl = window.location.href;
 if (reurl.indexOf('rjmms') > 0) {
    useRjAuthServer({
      axios: API,
      router,
      env: window._env_.NODE_ENV === 'pro' ? 'pro' : 'pro'
    });
 };

commonServer.getUserInfo().then(async (res) => {
  // 1.获取用户权限
  if (res.status === '200') {
    store.commit('setUserInfo', res.data);
    const lang = res.data.sysUser.lang || 'zh-CN';
    i18n.locale = lang;

    window.$core = window.$core || {};
    window.$core.locale = lang === 'en-US' ? 'en' : 'zh';
    window.$core.user = { userId: res?.data?.sysUser?.userId, userName: res?.data?.sysUser?.userName, email: res?.data?.email };

    window.localStorage.setItem('lang', lang);
    if (res.data.permissionDTO.allowApply && !res.data.otherOrganization) {
        // 2. 控制路由权限
        await menuAuthHandle();
        // 3.页面初始化
        new Vue({
          i18n,
          router,
          store,
          render: h => h(App)
        }).$mount('#app');
    } else {
      // 如果用户无权限，则跳转至401页面
      new Vue({
        router,
        store,
        render: h => h(App)
      }).$mount('#app');
      await router.replace('/401');
    }
  }
});

addClass(document.body, 'main');
// 异步启动子站
// setTimeout(() => {
//   startApp();
// }, 2000);

// export default APPVue;
